import React, { useRef } from 'react';
import classnames from 'classnames';
import Img from 'graphcms-image';

import CoverItems from './CoverItems';

const Cover = ({ explode = false, showShadow = false, items, ...props }) => {
  const ref = useRef();

  if (!props || !props.image) return null;

  return (
    <div className="relative" ref={ref}>
      <CoverItems items={items} container={ref} />
      <Img
        className={classnames('mx-auto rounded', {
          'lg:-mr-84': explode,
          'border shadow-lg': showShadow,
        })}
        maxWidth={960}
        transforms={['quality=value:75']}
        withWebp
        {...props}
      />
    </div>
  );
};

export default Cover;
